<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import { EndPointMarker, StartPointMarker, TrackedLocationPointMarker } from "@/constants/markers";

const { t } = useI18n();

type LegendMarker = google.maps.Symbol & { path: string; fillColor: string; strokeColor: string };

const startMarker = StartPointMarker as LegendMarker;
const endMarker = EndPointMarker as LegendMarker;
const trackedMarker = TrackedLocationPointMarker as LegendMarker;
</script>

<template>
  <div class="order-map-legend">
    <div class="d-flex align-center mt-3 order-map-legend__row">
      <div class="order-map-legend__icon">
        <span class="order-map-legend__pin-label order-map-legend__pin-label--start">Start</span>
        <svg height="26" viewBox="0 0 18 24" width="20">
          <path
            :d="startMarker.path"
            :fill="startMarker.fillColor"
            :stroke="startMarker.strokeColor"
            stroke-width="1"
          />
        </svg>
      </div>
      <span class="font-weight-500 ml-3 text-grey-darken-2">{{ t("maps.start-point") }}</span>
    </div>

    <div class="d-flex align-center mt-7 order-map-legend__row">
      <div class="order-map-legend__icon">
        <span class="order-map-legend__pin-label order-map-legend__pin-label--finish">Finish</span>
        <svg height="26" viewBox="0 0 18 24" width="20">
          <path :d="endMarker.path" :fill="endMarker.fillColor" :stroke="endMarker.strokeColor" stroke-width="1" />
        </svg>
      </div>
      <span class="font-weight-500 ml-3 text-grey-darken-2">{{ t("maps.finish-point") }}</span>
    </div>

    <div class="d-flex align-center mt-5 order-map-legend__row">
      <div class="order-map-legend__icon">
        <svg fill="none" height="20" viewBox="-2 -2 28 28" width="20">
          <path
            :d="trackedMarker.path"
            :fill="trackedMarker.fillColor"
            :stroke="trackedMarker.strokeColor"
            stroke-width="4"
          />
        </svg>
      </div>
      <span class="font-weight-500 ml-3 text-grey-darken-2">{{ t("maps.tracked-location-point") }}</span>
    </div>

    <div class="d-flex align-center mt-5 order-map-legend__row order-map-legend__row--route">
      <div class="order-map-legend__icon order-map-legend__icon--route"></div>
      <span class="font-weight-500 ml-3 text-grey-darken-2">{{ t("maps.truck-route") }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.order-map-legend {
  margin-top: 32px;
  padding-left: 4px;

  &__icon {
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 26px;
  }

  &__pin-label {
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 2px 4px;
    border-radius: 4px;
    color: $white;
    font-size: 10px;
    font-weight: 500;
    line-height: 12px;
    text-transform: uppercase;
    white-space: nowrap;

    &--start {
      background-color: $green;
    }

    &--finish {
      background-color: $danger;
    }
  }

  &__row--route {
    transform: translateX(4px);
  }

  &__icon--route {
    width: 26px;
    height: 6px;
    background-color: $indigo-accent-4;
    border-radius: 8px;
  }
}
</style>
